<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Value List
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.description"
                outlined
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.description"
              >
                <template v-slot:label>Description <span style="color:#f44336;font-weight:bold;">*</span></template>
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.code"
                outlined
                prepend-inner-icon="mdi-barcode"
                :error-messages="errors.code"
              >
                <template v-slot:label>Code <span style="color:#f44336;font-weight:bold;">*</span></template>
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Value List
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ValueListEditPage",
  data() {
    return {
      form: {
        description: "",
        code: "",
        is_active: true,
      },
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const encryptedId = this.$route.params.valueListId;
      try {
        const response = await axios.get(`/value_lists/${encryptedId}`);
        this.form = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.$store.dispatch("errors/setErrors", {});
        await axios.patch(`/value_lists/${this.$route.params.valueListId}`, this.form);
        this.isLoading = false;
        this.$router.push("/value-lists");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.$store.dispatch("errors/setErrors", e.response.data.errors);
        }
      }
    },
  },
};
</script>
